export const REQUEST_FORBIDDEN_NUMBERS_LIST = 'GET_FORBIDDEN_NUMBERS_LIST';
export const SUCCESS_FORBIDDEN_NUMBERS_LIST = 'SUCCESS_FORBIDDEN_NUMBERS_LIST';
export const FAILURE_FORBIDDEN_NUMBERS_LIST = 'FAILURE_FORBIDDEN_NUMBERS_LIST';
export const REQUEST_ADD_FORBIDDEN_NUMBER = 'REQUEST_ADD_FORBIDDEN_NUMBER';
export const SUCCESS_ADD_FORBIDDEN_NUMBER = 'SUCCESS_ADD_FORBIDDEN_NUMBER';
export const FAILURE_ADD_FORBIDDEN_NUMBER = 'FAILURE_ADD_FORBIDDEN_NUMBER';
export const REQUEST_DEL_FORBIDDEN_NUMBER = 'REQUEST_DEL_FORBIDDEN_NUMBER';
export const SUCCESS_DEL_FORBIDDEN_NUMBER = 'SUCCESS_DEL_FORBIDDEN_NUMBER';
export const FAILURE_DEL_FORBIDDEN_NUMBER = 'FAILURE_DEL_FORBIDDEN_NUMBER';
export const GET_FORBIDDEN_NUMBERS_TOTAL = 'GET_FORBIDDEN_NUMBERS_TOTAL';
export const IMPORT_FORBIDDEN_NUMBERS = 'IMPORT_FORBIDDEN_NUMBERS';